import { useEffect, useState } from "react";
import api from "../lib/api";

// Minimal list of active accounts (id, name, role, avatar) behind GET /users/directory. The server accepts prospects:assign,
// tasks:scope_all or tasks:edit; each page passes `enabled` from the rights it needs so nobody else sends a request bound to fail.
export default function useDirectory(enabled) {
  const [directory, setDirectory] = useState([]);
  useEffect(() => {
    if (!enabled) return undefined;
    let alive = true;
    api.get("/users/directory")
      .then(({ data }) => { if (alive) setDirectory(data); })
      .catch(() => {});
    return () => { alive = false; };
  }, [enabled]);
  return directory;
}
